'use strict';
module.exports = [
  require('./compare'),
  require('./compareNatural'),
  require('./compareText'),
  require('./deepEqual'),
  require('./equal'),
  require('./equalText'),
  require('./larger'),
  require('./largerEq'),
  require('./smaller'),
  require('./smallerEq'),
  require('./unequal')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/relational/index.js
// module id = 1819
// module chunks = 0